import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BehaviorSubject, Subject } from 'rxjs';

import { CaseViewApproveDialogComponent } from '../dg_core/actions/dg-approve/dg-approve.component';
import { DgAwaitComponent } from '../dg_core/actions/dg-await/dg-await.component';
import { DgDisposeComponent } from '../dg_core/actions/dg-dispose/dg-dispose.component';
import { ForwardCaseComponent } from '../dg_core/actions/dg-forward/dg-forward.component';
import { CaseViewNotApproveDialogComponent } from '../dg_core/actions/dg-not-approve/case-view-not-approve-dialog.component';
import { DgReturnComponent } from '../dg_core/actions/dg_return/dg-return.component';
import { SelectCaseDialogComponent } from '../dg_core/actions/selectCaseDialog/select-case-dialog.component';
import { CreateCaseComponent } from '../dg_core/create_case/create_case.component';
import { DeleteIntimationsComponent } from '../dg_core/delete-intimations/delete-intimations.component';
import { DgPageDeleteComponent } from '../dg_core/dg-page-delete/dg-page-delete.component';
import { DgPageDeleteallComponent } from '../dg_core/dg-page-deleteall/dg-page-deleteall.component';

import { MoveToFolderComponent } from '../dg_core/moveToFolder/moveToFolder.component';
import { PendencyComponent } from '../dg_core/pendency/pendency.component';
import { ReasonForAwaitingComponent } from '../dg_core/reason-for-awaiting/reason-for-awaiting.component';
import { ReasonForDisposingComponent } from '../dg_core/reason-for-disposing/reason-for-disposing.component';
import { ReturnToSenderComponent } from '../dg_core/return-to-sender/return-to-sender.component';
import { SelectAFileComponent } from '../dg_core/select-a-file/select-a-file.component';

import { SendWithinHeirarchyComponent } from '../dg_core/send-within-heirarchy/send-within-heirarchy.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DgReopenFileComponent } from '../dg_core/dg-reopen-file/dg-reopen-file.component';
import { DgSendcasenewComponent } from '../dg_core/dg-sendcasenew/dg-sendcasenew.component';
import { CorrespondanceAckComponent } from '../dg_core/correspondance-ack/correspondance-ack.component';
import { Menu } from '../models/menu.model';
import { TranslateService } from '@ngx-translate/core';
import { CustomActionComponentComponent } from '../dg_core/actions/custom-action-component/custom-action-component.component';
import { BulkReassignComponent } from '../dg_core/actions/bulk-reassign/bulk-reassign.component';
import { ReturnToInitiatorComponent } from '../dg_core/return-to-initiator/return-to-initiator.component';
import { DgReopenComponent } from '../dg_core/dg-actions/dg-reopen/dg-reopen.component';
import { DgRecallComponent } from '../dg_core/actions/dg-recall/dg-recall.component';
import { ParallelSendBackComponent } from '../dg_core/dg-actions/parallel-send-back/parallel-send-back.component';
import { RevokeCaseComponent } from '../dg_core/revoke-case/revoke-case.component';
import { CaseService } from './case.service';
import { AddRemoveUserToSharedGroupComponent } from '../dg_core/actions/add-remove-user-to-shared-group/add-remove-user-to-shared-group.component';
import { AddRemoveUserToSharedGroupService } from '../dg_core/actions/add-remove-user-to-shared-group/add-remove-user-to-shared-group.service';
import { GenericInfoComponent } from '../dg_core/generic-info/generic-info.component';
import { AppInitService } from './app-init.service';
import { PartFilesComponent } from '../dg_core/dg-actions/part-files/part-files.component';
// import { error } from 'console';
// import { catchError } from 'rxjs/operators';
import { catchError, map } from 'rxjs/operators';
import { ReOpenComponent } from '../dg_core/file-management/re-open/re-open.component';
import { PullFileComponent } from '../dg_core/file-management/pull-file/pull-file.component';

import { ReminderComponent } from '../dg_core/reminder/reminder.component';
import { NewCommuniqueComponent } from '../dg_core/communique/new-communique/new-communique.component';
import { DraftDialogComponent } from '../dg_components/dg-draft/draft-dialog/draft-dialog.component';
// import { error } from 'console';

@Injectable({ providedIn: 'root' })
export class ActionService {
  skipClicked: BehaviorSubject<boolean> = new BehaviorSubject(false);
  refreshCase: BehaviorSubject<boolean> = new BehaviorSubject(false);
  closeCase: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  closeTab: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  onCaseDtlsChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private _summaryChangeSubject: Subject<boolean> = new Subject();
  private _caseRefreshSubject: Subject<boolean> = new Subject();
  case: any;
  caseData: any;
  showDialouge = true;
  withinHierarchyData;
  showUnitsOptionFlagInWithinHierarchy = false;
  notingDtls;
  isCustomActionEnabledTP = false;
  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    public translate: TranslateService,
    private caseService: CaseService,
    private addRemoveUserService: AddRemoveUserToSharedGroupService,
    public appInitService: AppInitService
  ) {}

  customActionCall(
    actionName: string,
    selectedData: any,
    caseData,
    cases?: any[],
    id?: number,
    personalFolder?: any,
    selectedRow?: any,
    actionId?: any,
    subject?: any,
    menuItem?: any,
    dataForPost?: any,
    actionCode?: any,
    cmpFormId?: any,
    additionalDtls?: any
  ) {
    let postData = {
      caseId: Number(selectedData[0]?.docId),
      privId: !cmpFormId ? Number((menuItem?.menuItem as Menu)?.privId) : -1,
      cmpFormId: cmpFormId,
      appTypeId: Number(selectedData[0]?.appTypeId),
      ruleParams: dataForPost?.caseCorrObj?.ruleParams,
    };
    this.http
      .post('/workflow/on-click-rule-execution', postData)
      .subscribe((res: any) => {
        let temp = JSON.parse(res?.data);
        let flag = temp?.resultFlag;
        let templateId = temp?.templateId;
        let customActionData = temp?.customActionData;
        let actionComponentId = temp?.ACTION_COMPONENT_ID;
        let code = temp?.ACTION_CODE;
        let docTypeCode = temp?.documentCode ? temp?.documentCode : null;
        let action_Id = temp?.actionId ? temp?.actionId : null;
        let templateNotificationEventId = temp?.templateNotificationEventId
          ? temp?.templateNotificationEventId
          : null;
        //for false rule action requirement --start
        let acnName = temp?.PRIV_NAME
          ? temp?.PRIV_NAME
          : actionName
          ? actionName
          : menuItem?.menuItem?.PRIV_NAME;
        menuItem.menuItem.privId = temp?.PRIV_ID;
        menuItem.menuItem.PRIV_ID = temp?.PRIV_ID;
        //for false rule action requirement --end

        this.showDialouge = temp?.showDialouge ? temp?.showDialouge : false;
        this.showUnitsOptionFlagInWithinHierarchy =
          temp?.showUnitsOptionFlag?.toString() === '1' ? true : false;

        if (temp?.WITHIN_ACTION_DATA?.length > 0) {
          this.withinHierarchyData = { data: [] };
          temp?.WITHIN_ACTION_DATA?.forEach((e) => {
            if (this.withinHierarchyData?.data?.length > 0) {
              this.withinHierarchyData?.data?.[0]?.fileHierarchyVOArr?.push({
                empName: e?.empName,
                empId: e?.empId,
                unitId: e?.unitId,
                unitName: e?.unitName,
                unitLevel: e?.unitLevel,
                mpgTyp: e?.mpgTyp,
                nextRole: e?.nextRole,
                subHrchyLvlPk: e?.subHrchyLvlPk,
              });
            } else {
              this.withinHierarchyData?.data?.push({
                ...e,
                fileHierarchyVOArr: [
                  {
                    empName: e?.empName,
                    empId: e?.empId,
                    unitId: e?.unitId,
                    unitName: e?.unitName,
                    unitLevel: e?.unitLevel,
                    mpgTyp: e?.mpgTyp,
                    nextRole: e?.nextRole,
                    subHrchyLvlPk: e?.subHrchyLvlPk,
                  },
                ],
              });
            }
          });
        } else {
          this.withinHierarchyData = null;
        }
        if (cmpFormId) {
          menuItem.menuItem.PRIV_ID = temp?.PRIV_ID;
        }
        if (postData)
          if (!docTypeCode) {
            if (flag) {
              this.actionCall(
                acnName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                action_Id,
                subject,
                menuItem,
                dataForPost,
                code,
                true,
                customActionData,
                actionComponentId
              );
            }
          } else {
            selectedData[0].jobId =
              dataForPost?.caseCorrObj?.notingsVOArray[0]?.jobId;
            const dialogRef = this.dialog?.open(DraftDialogComponent, {
              data: {
                docTypeCode: docTypeCode,
                isFromCustomAction: true,
                case: selectedData[0],
                actionId: action_Id,
                templateNotificationEventId: templateNotificationEventId,
                dataForPost: dataForPost,
                additionalDtls: additionalDtls,
              },
              disableClose: true,
              width: '97vw',
              height: '97vh',
              maxHeight: '97vh',
              maxWidth: '97vw',
            });
            dialogRef?.afterClosed()?.subscribe((res: any) => {
              if (res?.canProceed) {
                this.actionCall(
                  acnName,
                  selectedData,
                  caseData,
                  cases,
                  id,
                  personalFolder,
                  selectedRow,
                  action_Id,
                  subject,
                  menuItem,
                  dataForPost,
                  code,
                  true,
                  customActionData,
                  actionComponentId
                );
              }
            });
          }
      });
    console.log('Implementation to be done for', actionName);
  }

  actionCall(
    actionName: string,
    selectedData: any,
    caseData,
    cases?: any[],
    id?: number,
    personalFolder?: any,
    selectedRow?: any,
    actionId?: any,
    subject?: any,
    menuItem?: any,
    dataForPost?: any,
    actionCode?: any,
    isFromCustomAction: boolean = false,
    customActionData?: any,
    actionComponentId?: any,
    showUnitSelectionWithInHierarchy: boolean = false
  ): any {
    this.case = cases;
    this.caseData = caseData;
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      this.isCustomActionEnabledTP = this.appInitService?.appConfig?.configurableFields?.isCustomActionEnabledTP;
      if (
        this.isCustomActionEnabledTP &&
        (actionCode === 613 || actionCode === 612)
      ) {
        isFromCustomAction = false;
      }
      if (!actionComponentId) {
        if (actionName === 'CreateCase') {
          const dialogRef = this.dialog.open(CreateCaseComponent);
          this.reload(
            dialogRef,
            actionName,
            selectedData,
            caseData,
            cases,
            id,
            personalFolder,
            selectedRow,
            actionId,
            subject,
            menuItem,
            dataForPost,
            actionCode,
            isFromCustomAction
          );
        } else if (
          actionName === 'DisposeCase' ||
          actionName === 'DisposeCaseInside' ||
          actionName === 'DisposeFromSeenCases' ||
          actionId === 464 ||
          actionId === 489 ||
          actionCode === 614
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            // SAVE should happen only from inside of the case
            // this.caseService.onCaseSave(selectedData).subscribe();
            //  let  CheckDispose = false;
            // if (actionName === 'DisposeCase') {
            const dialogRef = this.dialog.open(DgDisposeComponent, {
              width: '500px',
              data: {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
                defaultData: true,
              },
            });
            // }
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'SendCommunique' || actionId === 52006) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, {
              data: errorMsg,
            });
          } else if (selectedData.length > 1) {
            let errMsg = this.translate.instant(
              'select_Case_Dialog.Select_only_one'
            );
            this.dialog.open(SelectCaseDialogComponent, {
              data: errMsg,
            });
          } else {
            this.http.get('/admin/user-login-dtls')?.subscribe((res: any) => {
              let loggedinUserUnit = res.data.employeeVO?.allUnitVO[0]?.unitId;
              if (
                loggedinUserUnit.toString() ===
                selectedData[0].fileOwnerUnit.value
              ) {
                let errMsg = this.translate.instant(
                  'communique.case_owner_error'
                );
                this.dialog.open(SelectCaseDialogComponent, {
                  data: errMsg,
                });
              } else {
                const dialogRef = this.dialog.open(NewCommuniqueComponent, {
                  disableClose: true,
                  width: '75%',
                  height: '75%',
                  data: selectedData[0],
                });
                this.reload(
                  dialogRef,
                  actionName,
                  selectedData,
                  caseData,
                  cases,
                  id,
                  personalFolder,
                  selectedRow,
                  actionId,
                  subject,
                  menuItem,
                  dataForPost,
                  actionCode,
                  isFromCustomAction
                );
              }
            });
          }
        } else if (
          actionName === 'AwaitCase' ||
          actionName === 'AwaitCaseInside' ||
          actionId === 465 ||
          actionId === 490 ||
          actionCode === 699
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, {
              data: errorMsg,
            });
          } else {
            const dialogRef = this.dialog.open(DgAwaitComponent, {
              width: '500px',
              data: {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              },
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (
          actionName === 'ForwardCase' ||
          actionName === 'ForwardCaseInside' ||
          actionId === 477 ||
          actionId === 455 ||
          actionCode === 610
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(ForwardCaseComponent, {
              width: '600px',
              data: {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              },
            });
            // dialogRef.afterClosed().subscribe((res: any) => {
            //   return res;
            // });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
            /* dialogRef.afterClosed().subscribe((res)=>{
          console.log("Result is true");
          this.skipClicked.next (true);
        }) */
          }
        } else if (
          actionName === 'ReturnCase' ||
          actionName === 'ReturnCaseInside' ||
          actionId === 488 ||
          actionId === 463 ||
          actionCode === 611
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(DgReturnComponent, {
              width: '600px',
              data: {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              },
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (
          actionName === 'ReturnToSenderCase' ||
          actionName === 'ReturnToSenderCaseInside' ||
          actionId === 462 ||
          actionCode === 666
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(ReturnToSenderComponent, {
              width: '600px',
              data: {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              },
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (
          actionName === 'ReturnToInitiatorCase' ||
          actionName === 'ReturnToInitiatorCaseInside' ||
          actionCode === 10000080
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length >= 1) {
              const dialogRef = this.dialog.open(ReturnToInitiatorComponent, {
                width: '600px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            }
          }
        } else if (actionName === 'Recall') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(DgRecallComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
              /* dialogRef.afterClosed().subscribe((res) => {
              console.log('Result is true');
              this.skipClicked.next(true);
            }); */
            }
          }
        } else if (actionName === 'SendReminder') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(ReminderComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
              /* dialogRef.afterClosed().subscribe((res) => {
                  console.log('Result is true');
                  this.skipClicked.next(true);
                }); */
            }
          }
        } else if (actionName === 'Pull_AwaitCase') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(PullFileComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
              /* dialogRef.afterClosed().subscribe((res) => {
                    console.log('Result is true');
                    this.skipClicked.next(true);
                  }); */
            }
          }
        } else if (actionName === 'Pull_AllCorres') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: 'Please select a correspondence',
            });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(PullFileComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
              /* dialogRef.afterClosed().subscribe((res) => {
                    console.log('Result is true');
                    this.skipClicked.next(true);
                  }); */
            }
          }
        } else if (actionName === 'CreatePartFile') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              this.http
                .post('/case-mgmnt/create-part-file-popup', {
                  fileId: selectedData[0].docId,
                })
                ?.pipe(
                  map((response: any) => response?.widget_list),
                  catchError((error) => {
                    throw error;
                    console.log(error);
                  })
                )
                .subscribe(
                  (res) => {
                    const dialogRef = this.dialog.open(PartFilesComponent, {
                      width: '100vw',
                      height: '100vh',
                      data: {
                        selectedData: selectedData,
                        isFromCustomAction: isFromCustomAction,
                      },
                    });
                    this.reload(
                      dialogRef,
                      actionName,
                      selectedData,
                      caseData,
                      cases,
                      id,
                      personalFolder,
                      selectedRow,
                      actionId,
                      subject,
                      menuItem,
                      dataForPost,
                      actionCode,
                      isFromCustomAction
                    );
                    console.log(res);
                  },
                  (error) => {
                    console.log(error.Status);
                  }
                );

              /* dialogRef.afterClosed().subscribe((res) => {
                    console.log('Result is true');
                    this.skipClicked.next(true);
                  }); */
            }
          }
        } else if (actionName === 'ParallelSendBack') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(ParallelSendBackComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            }
          }
        } else if (
          actionName === 'revokeCase' ||
          actionName === 'revokeCaseInside' ||
          actionName === 'revokeCorr' ||
          actionName === 'revokeCorrInside'
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(RevokeCaseComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            }
          }
        } else if (actionName === 'MoveToWorklistInside') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length) {
              const dialogRef = this.dialog.open(DgReopenComponent, {
                width: '300px',
                data: {
                  selectedData: selectedData,
                  isFromCustomAction: isFromCustomAction,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            }
          }
        } else if (actionName === 'BlankPage') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant(
                'select_Case_Dialog.Select_atleast_one'
              ),
            });
          } else {
            const dialogRef = this.dialog.open(ReOpenComponent, {
              width: '500px',

              data: selectedData,
              disableClose: true,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'Open_AllCorres') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: 'Please select a correspondence',
            });
          } else {
            const dialogRef = this.dialog.open(ReOpenComponent, {
              width: '500px',

              data: selectedData,
              disableClose: true,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (
          actionName === 'MoveToFolder' ||
          actionName === 'MoveToFolderInside'
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(MoveToFolderComponent, {
              width: '650px',
              data: {
                selectedData: selectedData,
                applTypeId: id,
                personalFolder: personalFolder,
              },
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (
          actionName === 'ApproveCase' ||
          actionId === 474 ||
          actionCode === 612
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (!isFromCustomAction) {
              const dialogRef = this.dialog.open(
                CaseViewApproveDialogComponent,
                {
                  width: '600px',
                  data: {
                    selectedData: selectedData,
                    isFromCustomAction: isFromCustomAction,
                  },
                }
              );
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            } else {
              let caseApproveComponent = new CaseViewApproveDialogComponent(
                null,
                null,
                null,
                null,
                null,
                null
              );
              caseApproveComponent.caseData = selectedData[0];
              caseApproveComponent.docId = selectedData[0]?.docId;
              caseApproveComponent.data = {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              };
              this.callOnClickAction(
                selectedData,
                menuItem,
                dataForPost,
                caseApproveComponent?.onSubmit(true),
                actionCode,
                actionComponentId
              );
            }
          }
        } else if (
          actionName === 'NotApprove' ||
          actionName === 'RejectCase' ||
          actionId === 475 ||
          actionCode === 613
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (!isFromCustomAction) {
              const dialogRef = this.dialog.open(
                CaseViewNotApproveDialogComponent,
                {
                  width: '600px',
                  data: {
                    selectedData: selectedData,
                    isFromCustomAction: isFromCustomAction,
                  },
                }
              );
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            } else {
              let caseNotApproveComponent = new CaseViewNotApproveDialogComponent(
                null,
                null,
                null,
                null,
                null,
                null
              );
              caseNotApproveComponent.caseData = selectedData[0];
              caseNotApproveComponent.docId = selectedData[0]?.docId;
              caseNotApproveComponent.data = {
                selectedData: selectedData,
                isFromCustomAction: isFromCustomAction,
              };
              this.callOnClickAction(
                selectedData,
                menuItem,
                dataForPost,
                caseNotApproveComponent?.onSubmit(true),
                actionCode,
                actionComponentId
              );
            }
          }
        } else if (actionName === 'Send Case') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            if (selectedData?.length === 1) {
              const dialogRef = this.dialog.open(DgSendcasenewComponent, {
                data: selectedRow ? selectedRow : selectedData,
                disableClose: true,
                autoFocus: false,
                width: '80vw',
                height: '96vh',
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            } else {
              let errMsg = this.translate.instant(
                'select_Case_Dialog.Select_only_one'
              );
              this.dialog.open(SelectCaseDialogComponent, { data: errMsg });
            }
          }
        } else if (
          actionName === 'WithinHierarchy_Case_Main' ||
          actionName === 'WithinHierarchy_Case' ||
          actionId === 491 ||
          actionCode === 993
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            //if (selectedData?.length === 1) {
            selectedData[0].actionId = '993';
            if (this.showDialouge) {
              if (!isFromCustomAction) {
                this.showUnitsOptionFlagInWithinHierarchy = showUnitSelectionWithInHierarchy;
              }
              const dialogRef = this.dialog.open(SendWithinHeirarchyComponent, {
                width: this.showUnitsOptionFlagInWithinHierarchy
                  ? '900px'
                  : '600px',
                data: {
                  data: selectedData,
                  isFromCustomAction: isFromCustomAction,
                  withinHierarchyData: this.withinHierarchyData,
                  actionName: actionName,
                  showUnitsOptionFlag: this
                    .showUnitsOptionFlagInWithinHierarchy,
                },
              });
              this.reload(
                dialogRef,
                actionName,
                selectedData,
                caseData,
                cases,
                id,
                personalFolder,
                selectedRow,
                actionId,
                subject,
                menuItem,
                dataForPost,
                actionCode,
                isFromCustomAction
              );
            } else {
              if (isFromCustomAction) {
                this.callOnClickAction(
                  selectedData,
                  menuItem,
                  dataForPost,
                  null,
                  actionCode
                );
              }
            }
            // } else {
            //   let errMsg = this.translate.instant(
            //     'select_Case_Dialog.Select_only_one'
            //   );
            //   this.dialog.open(SelectCaseDialogComponent, { data: errMsg });
            // }
          }
        } else if (actionName === 'CasePendency') {
          this.dialog.open(PendencyComponent, {
            width: '800px',
            data: caseData,
          });
        } else if (actionName === 'SendToAnyOne_Case_Main') {
        } else if (actionName == 'DeleteIntimation') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant('intimation.Select_case'),
            });
          } else {
            const dialogRef = this.dialog.open(DeleteIntimationsComponent, {
              data: selectedData,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
          //this.getInitialData();
        } else if (actionName == 'ReasonForAwaitingCase') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant('select_Case_Dialog.Select_case'),
            });
          } else if (selectedData.length == 1) {
            const dialogRef = this.dialog.open(ReasonForAwaitingComponent, {
              data: selectedData,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          } else {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant('select_Case_Dialog.Select_only'),
            });
          }
        } else if (actionName == 'ReasonForRecordingCase') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant('select_Case_Dialog.Select_case'),
            });
          } else if (selectedData.length == 1) {
            const dialogRef = this.dialog.open(ReasonForDisposingComponent, {
              data: selectedData,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          } else {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant('select_Case_Dialog.Select_only'),
            });
          }
        } else if (actionName === 'Open_DisposedCase') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant(
                'select_Case_Dialog.Select_atleast_one'
              ),
            });
          } else {
            const dialogRef = this.dialog.open(DgReopenFileComponent, {
              data: selectedData,
              disableClose: true,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'Open_AwaitCase') {
          if (!selectedData || !selectedData.length) {
            this.dialog.open(SelectAFileComponent, {
              data: this.translate.instant(
                'select_Case_Dialog.Select_atleast_one'
              ),
            });
          } else {
            const dialogRef = this.dialog.open(DgReopenFileComponent, {
              data: selectedData,
              disableClose: true,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'DeleteAllSentCase') {
          const dialogRef = this.dialog.open(DgPageDeleteallComponent);
          this.reload(
            dialogRef,
            actionName,
            selectedData,
            caseData,
            cases,
            id,
            personalFolder,
            selectedRow,
            actionId,
            subject,
            menuItem,
            dataForPost,
            actionCode,
            isFromCustomAction
          );
        } else if (actionName === 'DeleteSentCase') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(DgPageDeleteComponent, {
              data: selectedData,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'fileClose' || actionId === '483') {
          const index = cases.findIndex((element) => {
            if (element.value === caseData[0].value) return true;
          });
          cases.splice(index, 1);
          this.skipClicked.next(true);
          setTimeout(() => {
            this.skipClicked.next(false);
          }, 2000);
        } else if (
          actionName === 'CreateCaseFrmCorr' ||
          actionName === 'CreateCaseFrmCorrInside'
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else if (selectedData.length > 1) {
            this.dialog.open(SelectCaseDialogComponent, {
              data: this.translate.instant('select_Case_Dialog.Select_only'),
            });
          } else {
            const dialogRef = this.dialog.open(CreateCaseComponent, {
              width: '700px',
              data: { selectedData: selectedRow[0], isFromCorr: true },
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
            //this.createCase.fromCaseCorr(selectedRow[0]);
            /* dialogRef.afterClosed().subscribe((res)=>{
          console.log("Result is true");
          this.skipClicked.next (true);
        }) */
          }
        } else if (
          actionName === 'CorrAcknowledgement' ||
          actionName === 'CorrAcknowledgementInside'
        ) {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, {
              data: errorMsg,
            });
          } else {
            const dialogRef = this.dialog.open(CorrespondanceAckComponent, {
              width: '25%',
              data: selectedData,
            });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'PullToWorklist') {
          console.log('into pull worklist');
          if (selectedData.length) {
            const filterData = selectedData.map((x) => {
              return parseInt(x.docId.toString());
            });
            const postObj = {
              refId: filterData,
              applTypeId: 1,
            };
            this.http
              .post('/workflow/pull-to-worklist-from-group', postObj)
              .subscribe(() => {
                this.skipClicked.next(true);
              });
          } else {
            this.dialog.open(SelectCaseDialogComponent, {
              data: 'Please select support request ticket',
            });
          }
        } else if (menuItem?.menuItem?.privURL === 'Reassign Cases') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(BulkReassignComponent, {
              width: '900px',
              height: '97vh',
              data: {
                selectedData: selectedRow,
              },
              autoFocus: false,
            });
            // dialogRef.afterClosed().subscribe((res: any) => {
            //   return res;
            // });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
            /* dialogRef.afterClosed().subscribe((res)=>{
          console.log("Result is true");
          this.skipClicked.next (true);
        }) */
          }
        } else if (menuItem?.menuItem?.privURL === 'Close and Release') {
          let refIds = [];

          selectedData?.forEach((ele) => {
            refIds.push(Number(ele?.docId));
          });

          let postData = {
            refId: refIds,
            applTypeId: 1,
            toUnit: [],
            toMpgType: [658],
            toGrpId: null,
            toType: 1970,
            movmentActionFlag: null,
          };

          this.http
            ?.post('/workflow/reassign-case', postData)
            ?.subscribe((res: any) => {
              this.skipClicked.next(res);
              this.skipClicked.next(false);
            });
        } else if (menuItem?.menuItem?.privURL === 'Add_User_Shared_Group') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            this.addRemoveUserService.caseData = selectedData[0];
            this.addRemoveUserService.from = actionName;
            const dialogRef = this.dialog.open(
              AddRemoveUserToSharedGroupComponent,
              {
                width: '900px',
                height: '97vh',
                autoFocus: false,
              }
            );
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
          }
        } else if (actionName === 'UpdateHierarchy') {
          if (!selectedData || !selectedData.length) {
            let errorMsg = this.translate.instant(
              'select_Case_Dialog.Select_case'
            );
            this.dialog.open(SelectCaseDialogComponent, { data: errorMsg });
          } else {
            const dialogRef = this.dialog.open(GenericInfoComponent, {
              width: '800px',
              height: '500px',
              data: {
                caseDetails: selectedData?.[0],
                case: selectedData?.[0],
                isFromOutboxCases: false,
                isGenericAprCase: false,
              },
            });
            // dialogRef.afterClosed().subscribe((res: any) => {
            //   return res;
            // });
            this.reload(
              dialogRef,
              actionName,
              selectedData,
              caseData,
              cases,
              id,
              personalFolder,
              selectedRow,
              actionId,
              subject,
              menuItem,
              dataForPost,
              actionCode,
              isFromCustomAction
            );
            /* dialogRef.afterClosed().subscribe((res)=>{
          console.log("Result is true");
          this.skipClicked.next (true);
        }) */
          }
        } else {
          if (isFromCustomAction) {
            this.callOnClickAction(
              selectedData,
              menuItem,
              dataForPost,
              null,
              actionCode
            );
          }
        }
      } else {
        const dialogRef = this.dialog.open(CustomActionComponentComponent, {
          width: '500px',
          data: {
            selectedData: selectedData,
            isFromCustomAction: isFromCustomAction,
            configuredJson: customActionData,
            actionComponentId: actionComponentId,
          },
        });
        this.reload(
          dialogRef,
          actionName,
          selectedData,
          caseData,
          cases,
          id,
          personalFolder,
          selectedRow,
          actionId,
          subject,
          menuItem,
          dataForPost,
          actionCode,
          isFromCustomAction,
          customActionData,
          actionComponentId
        );
      }
    });
  }

  reload(
    dialogRef,
    actionName: string,
    selectedData: any,
    caseData,
    cases?: any[],
    id?: number,
    personalFolder?: any,
    selectedRow?: any,
    actionId?: any,
    subject?: any,
    menuItem?: any,
    dataForPost?: any,
    actionCode?: any,
    isFromCustomAction: boolean = false,
    customActionData?: any,
    actionComponentId?: any
  ) {
    dialogRef.afterClosed().subscribe((res) => {
      if (isFromCustomAction && res) {
        this.callOnClickAction(
          selectedData,
          menuItem,
          dataForPost,
          res,
          actionCode,
          actionComponentId
        );
      } else {
        this.skipClicked.next(!!res);
        this.skipClicked.next(false);
      }
    });
  }

  callOnClickAction(
    selectedData,
    menuItem,
    dataForPost,
    res,
    actionCode,
    actionComponentId?: any
  ): void {
    let jsonData = {
      caseId: Number(selectedData[0]?.docId),
      appTypeId: Number(selectedData[0]?.appTypeId),
      privId: Number(menuItem?.menuItem?.PRIV_ID),
      docDetails: dataForPost,
      sendDocWithLinkedFilesVO:
        actionCode === 610 ||
        actionCode === 611 ||
        actionCode === 666 ||
        actionCode === 10000080
          ? res
          : actionCode === 993 && res?.toUnit?.length > 0
          ? res
          : null,
      notificationMap: {
        param: {
          'Employee VO': {
            'Employee Id': 100003323,
          },
        },
      },
      recordDisposalVO: actionCode === 614 ? res[0] : null,
      awaitVO:
        actionCode === 699
          ? actionComponentId
            ? res?.awaitVO[0]
            : res?.awaitVO[0]
          : null,
      approveRejectVO: actionCode === 612 || actionCode === 613 ? res : null,
      customActionData: actionComponentId ? res?.customActionData : null,
      additionalDtls: { ...selectedData[0] },
    };
    // if (actionCode !== 614) {
    //   jsonData.recordDisposalVO = null;
    // } else {
    //   jsonData.sendDocWithLinkedFilesVO = null;
    //   jsonData.recordDisposalVO = res[0];
    // }
    // if (actionCode !== 699) {
    //   jsonData.awaitVO = null;
    // } else {
    //   jsonData.sendDocWithLinkedFilesVO = null;
    //   jsonData.awaitVO = res[0];
    // }
    // if (actionCode === 993) {
    //   jsonData.sendDocWithLinkedFilesVO = {
    //     movmentActionFlag: 4,
    //     langId: 1,
    //     locId: 1,
    //     refId: [Number(selectedData[0].docId)],
    //     applTypeId: 1,
    //   };
    // }
    // if (actionCode !== 612 || actionCode !== 613) {
    //   jsonData.approveRejectVO = null;
    // }

    delete jsonData?.additionalDtls?.componentAddress;
    delete jsonData?.additionalDtls?.componentInputs;
    delete jsonData?.additionalDtls?.componentOutputIds;
    delete jsonData?.additionalDtls?.componentOutputs;

    this.http
      .post('/workflow/on-click-action', jsonData)
      ?.subscribe((res: any) => {
        res = JSON.parse(res?.data[0]);
        if (res?.actionResult) {
          if (res?.worklistCaseCloseFlag) {
            this.skipClicked.next(res?.actionResult);
            setTimeout(() => {
              this.skipClicked.next(false);
            }, 2000);
          } else {
            this.refreshCase.next(true);
          }
        }
      });
  }

  fileClose() {
    const index = this.case.findIndex((element) => {
      if (element.docId === this.caseData[0].docId) return true;
    });
    this.case.splice(index, 1);
  }

  get summaryChangeSubject() {
    return this._summaryChangeSubject;
  }

  get SummaryChangeObservable() {
    return this._summaryChangeSubject?.asObservable();
  }

  get caseRefreshSubject() {
    return this._caseRefreshSubject;
  }

  get caseRefreshObservable() {
    return this._caseRefreshSubject?.asObservable();
  }
}
